import Vue from 'vue';

import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faSearch,
    faArrowAltCircleUp,
    faArrowLeft,
    faArrowRight,
    faUser,
    faEnvelope,
    faPhone,
    faPlus,
    faMinus,
    faCalendar,
    faMinusSquare,
    faCommentAlt,
    faShoppingCart,
    faDownload,
    faAngleDown,
    faAngleUp,
    faComments,
    faClipboard,
    faFileAlt,
    faUsers,
    faAt,
    faSitemap,
    faFile,
    faProjectDiagram,
    faPencilAlt,
    faCompressArrowsAlt,
    faExternalLinkAlt,
    faLocationArrow,
    faInfo,
    faEnvelopeOpen,
    faCloudUploadAlt,
    faTrashAlt,
    faCheck,
    faTimes,
    faFileImage,
    faFileVideo,
    faFileArchive,
    faFileWord,
    faFilePowerpoint,
    faFileExcel,
    faFileCsv,
    faFileAudio,
} from '@fortawesome/free-solid-svg-icons';

config.searchPseudoElements = true;
config.autoReplaceSvg = 'nest';

import { faTwitter, faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';

library.add(faSearch);
library.add(faArrowAltCircleUp);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faUser);
library.add(faAt);
library.add(faEnvelope);
library.add(faPhone);
library.add(faPlus);
library.add(faMinus);
library.add(faMinusSquare);
library.add(faCalendar);
library.add(faCommentAlt);
library.add(faShoppingCart);
library.add(faDownload);
library.add(faAngleDown);
library.add(faAngleUp);
library.add(faComments);
library.add(faClipboard);
library.add(faFileAlt);
library.add(faUsers);
library.add(faSitemap);
library.add(faFile);
library.add(faCheck);
library.add(faProjectDiagram);
library.add(faPencilAlt);
library.add(faCompressArrowsAlt);
library.add(faExternalLinkAlt);
library.add(faFacebookF);
library.add(faTwitter);
library.add(faInstagram);
library.add(faLocationArrow);
library.add(faInfo);
library.add(faEnvelopeOpen);
library.add(faCloudUploadAlt);
library.add(faTrashAlt);
library.add(faCheck);
library.add(faTimes);
library.add(faFileImage);
library.add(faFileVideo);
library.add(faFileArchive);
library.add(faFileWord);
library.add(faFilePowerpoint);
library.add(faFileExcel);
library.add(faFileCsv);
library.add(faFileAudio);
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
